module.exports = __webpack_public_path__ + "static/media/termeni-conditii-POLONIQ.ddd194b9.pdf";